import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Alert_v2 extends Base {
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  list(payload) {
    const url = this._getFullURL(`/alert/list`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  listActionMachine(payload) {
    const url = this._getFullURL(`/alert/list-close-action/machine`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  listByDate(payload) {
    const url = this._getFullURL(`/alert/by-date/machine`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  listByMachine(payload) {
    const url = this._getFullURL(`/alert/by-machine/machine`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  getOne(id) {
    const url = this._getFullURL(`/alert/one-alert/${id}`);
    const payload = {};
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  getAnomalyClassification(id) {
    const url = this._getFullURL(`/alert/one-anomaly-classification/${id}`);
    const payload = {};
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  addComment(id, payload) {
    const url = this._getFullURL(`/alert/add-comment/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  addLog(id, payload) {
    const url = this._getFullURL(`/alert/add-log/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  addLogAction(id, payload, photoFile) {
    const url = this._getFullURL(`/alert-logs/add-log-action/${id}`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);
    var formdata = new FormData();
    formdata.append("files", photoFile);
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  addChat(id, payload) {
    const url = this._getFullURL(`/alert/add-chat/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  addChatGeneral(payload) {
    const url = this._getFullURL(`/alert/add-chat-general/public`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  askGina(id, payload) {
    const url = this._getFullURL(`/alert/ask-gina/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  askGinaGeneral(payload) {
    const url = this._getFullURL(`/alert/ask-gina-general/general`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description add log Attachment
   * @returns {Promise<Response>}
   */
  addLogAttachment(id, payload, photoFile) {
    const url = this._getFullURL(`/alert-logs/add-log-attachment/${id}`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);
    var formdata = new FormData();
    formdata.append("files", photoFile);
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  addLogFeedbackAttachment(id, payload, photoFile) {
    const url = this._getFullURL(`/alert-logs/add-log-attachment/${id}`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);
    var formdata = new FormData();
    formdata.append("files", photoFile);
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  getAlertLogs(id) {
    const url = this._getFullURL(`/alert/logs/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "GET",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  deleteFeedback(row) {
    const { alert_logs_id, created_at } = row;
    const url = this._getFullURL(
      `/alert-logs/logs/${alert_logs_id}/${created_at}`
    );
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "DELETE",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  getVibrationChart(id, payload) {
    const url = this._getFullURL(`/alert/one-vibration/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  getChat(id) {
    const url = this._getFullURL(`/alert/chat/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "GET",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  getChatGeneral() {
    const url = this._getFullURL(`/alert/chat-general/public`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "GET",
      })
    );
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  getMachine() {
    const url = this._getFullURL(`/alert/machine/all`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "GET",
      })
    );
  }
}
